export default __webpack_public_path__ + "static/media/image66.795a1d78.jpg";